import Error from 'components/error/error.component';
import {
  ErrorBoundary as REB,
  ErrorBoundaryPropsWithRender,
} from 'react-error-boundary';
import { useDefaultOnReset } from './error-boundary.hooks';
import { defaultErrorHandler } from './error-boundary.utils';
import TestError from './test-error/test-error.component';

type ErrorBoundaryProps = Partial<ErrorBoundaryPropsWithRender> & {
  name: string;
  children: React.ReactNode;
};

const ErrorBoundary = ({
  name,
  fallbackRender = props => <Error ebName={name} {...props} />,
  onError = defaultErrorHandler(name),
  onReset,
  children,
  ...rest
}: ErrorBoundaryProps) => {
  const defaultOnReset = useDefaultOnReset();

  return (
    <REB
      fallbackRender={fallbackRender}
      onError={onError}
      onReset={onReset || defaultOnReset}
      {...rest}
    >
      <TestError name={name} />
      {children}
    </REB>
  );
};

export default ErrorBoundary;
